(function () {
  const moveTo = new MoveTo({
    tolerance: 0,
    duration: 800,
    easing: 'easeOutQuart',
    container: window,
  });

  const scrollTo = document.getElementsByClassName('scrollTo');
  Array.prototype.forEach.call(scrollTo, function (el) {
    moveTo.registerTrigger(el);
  });
})();
